var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8389 8.40985C13.0537 8.18416 13.0537 7.81579 12.8389 7.59011L8.63225 3.16955C8.41715 2.94351 8.06726 2.94351 7.85219 3.16955L7.61689 3.41682C7.4016 3.64306 7.40156 4.01055 7.61686 4.23684L10.808 7.59001C11.0233 7.81624 11.0233 8.18381 10.808 8.41005L7.61689 11.7632C7.40156 11.9895 7.40158 12.357 7.61691 12.5832L7.85221 12.8305C8.06698 13.0562 8.41751 13.0562 8.63227 12.8305L12.8389 8.40985ZM4.17672 12.8306C3.96175 13.0565 3.61152 13.0565 3.39655 12.8306L3.16124 12.5833C2.94637 12.3575 2.94634 11.9891 3.16124 11.7633L6.35221 8.41005C6.56752 8.18379 6.56752 7.81627 6.35221 7.59L3.16122 4.23681C2.94625 4.01092 2.94627 3.64268 3.16122 3.41679L3.39653 3.16952C3.6116 2.94351 3.96163 2.94348 4.1767 3.16952L8.00972 7.19768C9.08492 6.06889 8.81295 6.35515 8.0105 7.1985L8.38312 7.59011C8.59802 7.81594 8.598 8.18404 8.38312 8.40987L4.17672 12.8306Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideArrows);
export default __webpack_public_path__ + "static/media/hide-arrows.64a640fa76cb879d968ec3c6af388a71.svg";
export { ForwardRef as ReactComponent };